import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import { Modal } from "../Modal/Modal";
import TermsAndConditionsModal from "../Modal/TermsAndConditionsModal";
import AcceptableUseModal from "../Modal/AcceptableUseModal";
import PrivacyPolicyModal from "../Modal/PrivacyPolicyModal";
import CookiePolicyModal from "../Modal/CookiePolicyModal";
import {
  PolicyFooterStyles,
  DotContainer,
  LinkContainer,
  LegalLink,
} from "./styles";
import { POLICY_TYPES } from "../../utils/constants";
import ReportAnIssueModal from "../Modal/ReportAnIssueModal";
import IgniteSurveyForm from "../Modal/IgniteSurveyForm";
import TutorialModal from "../Modal/TutorialModal";
import useScreenType from "react-screentype-hook";

export const Policy: React.FC<{ type: "footer" | "sidebar" }> = ({ type }) => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAcceptableUseModal, setShowAcceptableUseModal] = useState(false);
  const [showTermsAndConditionsModal, setShowTermsAndConditions] =
    useState(false);
  const [showReportAnIssueModal, setShowReportAnIssueModal] = useState(false);
  const [isSurveyModalOpen, setIsSurveyModalOpen] = useState(false);
  const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false);
  const [showCookiePolicyModal, setShowCookiePolicyModal] = useState(false);

  const navigate = useNavigate();
  const { isMobile } = useScreenType();

  useEffect(() => {
    const queryStrings = queryString.parse(location.search);
    const hasPrivacy = POLICY_TYPES.PRIVACY in queryStrings;
    const hasTermsAndConditions =
      POLICY_TYPES.TERMS_AND_CONDITIONS in queryStrings;
    const hasAcceptableUsePolicy = POLICY_TYPES.ACCEPTABLE_USE in queryStrings;
    const hasCookiePolicy = POLICY_TYPES.COOKIE in queryStrings;

    if (hasPrivacy) {
      setShowPrivacyModal(true);
    }

    if (hasAcceptableUsePolicy) {
      setShowAcceptableUseModal(true);
    }

    if (hasTermsAndConditions) {
      setShowTermsAndConditions(true);
    }

    if (hasCookiePolicy) {
      setShowCookiePolicyModal(true);
    }
  }, [location.search]);

  const openModal = (type: POLICY_TYPES) => {
    navigate(`${location.pathname}?${type}`);
  };

  const closeModal = (type: POLICY_TYPES) => {
    switch (type) {
      case POLICY_TYPES.ACCEPTABLE_USE:
        setShowAcceptableUseModal(false);
        break;
      case POLICY_TYPES.PRIVACY:
        setShowPrivacyModal(false);
        break;
      case POLICY_TYPES.TERMS_AND_CONDITIONS:
        setShowTermsAndConditions(false);
        break;
      case POLICY_TYPES.COOKIE:
        setShowCookiePolicyModal(false);
        break;
    }
    navigate("/");
  };

  return (
    <>
      {(type === "sidebar" || !type) && (
        <LinkContainer $isMobile={isMobile}>
          <div>
            <LegalLink onClick={() => openModal(POLICY_TYPES.PRIVACY)}>
              Privacy Policy
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink onClick={() => openModal(POLICY_TYPES.ACCEPTABLE_USE)}>
              Acceptable Use Policy
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink
              onClick={() => openModal(POLICY_TYPES.TERMS_AND_CONDITIONS)}
            >
              Terms and Conditions
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink onClick={() => setShowReportAnIssueModal(true)}>
              Report an issue
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink onClick={() => setIsSurveyModalOpen(true)}>
              Take the survey
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink onClick={() => setIsTutorialModalOpen(true)}>
              Ignite tutorials
            </LegalLink>
          </div>
          <div style={{ marginTop: "8px" }}>
            <LegalLink onClick={() => openModal(POLICY_TYPES.COOKIE)}>
              Cookie Policy
            </LegalLink>
          </div>
        </LinkContainer>
      )}
      {type === "footer" && (
        <PolicyFooterStyles>
          <div className="link-wrapper">
            <a onClick={() => openModal(POLICY_TYPES.ACCEPTABLE_USE)}>
              Acceptable Use Policy
            </a>
            <DotContainer>
              <>&#183;</>
            </DotContainer>
            <a onClick={() => openModal(POLICY_TYPES.PRIVACY)}>
              Privacy Policy
            </a>
            <DotContainer>
              <>&#183;</>
            </DotContainer>
            <a onClick={() => openModal(POLICY_TYPES.TERMS_AND_CONDITIONS)}>
              Terms and conditions
            </a>
            <DotContainer>
              <>&#183;</>
            </DotContainer>
            <a onClick={() => setShowReportAnIssueModal(true)}>
              Report an issue
            </a>
            <DotContainer>
              <>&#183;</>
            </DotContainer>
            <a onClick={() => setIsTutorialModalOpen(true)}>
              Ignite Tutorials
            </a>
          </div>
          <DotContainer>
            <>&#183;</>
          </DotContainer>
          <a onClick={() => openModal(POLICY_TYPES.COOKIE)}>
            Cookie Policy
          </a>
        </PolicyFooterStyles>
      )}
      {showPrivacyModal && (
        <PrivacyPolicyModal
          isOpen={showPrivacyModal}
          onClose={() => closeModal(POLICY_TYPES.PRIVACY)}
        />
      )}
      {showAcceptableUseModal && (
        <AcceptableUseModal
          isOpen={showAcceptableUseModal}
          onClose={() => closeModal(POLICY_TYPES.ACCEPTABLE_USE)}
        />
      )}
      {showTermsAndConditionsModal && (
        <TermsAndConditionsModal
          isOpen={showTermsAndConditionsModal}
          onClose={() => closeModal(POLICY_TYPES.TERMS_AND_CONDITIONS)}
        />
      )}
      {showReportAnIssueModal && (
        <ReportAnIssueModal
          isOpen={showReportAnIssueModal}
          onClose={() => setShowReportAnIssueModal(false)}
        />
      )}
      {isSurveyModalOpen && (
        <Modal
          // @ts-ignore
          isOpen={isSurveyModalOpen}
          onClose={() => setIsSurveyModalOpen(false)}
        >
          <IgniteSurveyForm />
        </Modal>
      )}
      {isTutorialModalOpen && (
        <TutorialModal
          isOpen={isTutorialModalOpen}
          onClose={() => setIsTutorialModalOpen(false)}
        />
      )}

      {showCookiePolicyModal && (
      <CookiePolicyModal
        isOpen={showCookiePolicyModal}
        onClose={() => closeModal(POLICY_TYPES.COOKIE)}
      />
    )}
    </>
  );
};
